<template>
  <div :id="name + '-dropdown-container'" style="position: relative;">
    <input type="text" v-model="complete" @keyup="completeChange" class="dropdown-toggle"
           :id="name + '-dropdown-button'" data-toggle="dropdown" aria-haspopup="true"
           aria-expanded="false" style="width: 100%;" :class="inputClass" :disabled="disabled"
           autocomplete="off"
    >
    <ul class="dropdown-menu" role="menu" style="width: 100%;">
      <li v-if="noSugestions">
        <a>Digite para pesquisar</a>
      </li>
      <li><a v-for="item in sugestions" @click="chooseItem(item.id, item.name)">{{ item.name }}</a></li>
    </ul>
  </div>
</template>

<script>

export default {
  data() {
    return {
      complete: '',
      sugestions: [],
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    maxAutoShow: {
      type: Number,
      required: false,
      default: 10,
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    $('.dropdown-toggle').dropdown();
    this.verifyAutoShow(this.list);
  },
  watch: {
    list(val) {
      this.verifyAutoShow(val);
    },
  },
  computed: {
    noSugestions() {
      return this.sugestions.length === 0;
    },
  },
  methods: {
    setOption(id) {
      const option = this.list.filter(o => o.id === id)[0];
      if (option) {
        this.complete = option.name;
      }
    },
    clear() {
      this.complete = '';
      this.sugestions = [];
    },
    verifyAutoShow(items) {
      if (items.length === 0) {
        this.autoShowEnabled = false;
        this.sugestions = [];
      } else if (this.maxAutoShow && items.length < this.maxAutoShow) {
        this.sugestions = items;
        this.autoShowEnabled = true;
      }
    },
    chooseItem(id, name) {
      this.$emit('selected', id, name);
      this.complete = name;
    },
    completeChange() {
      if (this.autoShowEnabled) {
        return;
      }
      if (this.complete.length >= 3) {
        const completeParsed = this.complete.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        this.sugestions = this.list.filter(item => item.name.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase()
          .includes(completeParsed.toUpperCase()));

        if (this.sugestions.length > 0) {
          if (!$(`#${this.name}-dropdown-container`).hasClass('open')) {
            $(`#${this.name}-dropdown-button`).trigger('click.bs.dropdown');
          }
        }
      } else if (this.complete.length === 0) {
        this.sugestions = [];
        if ($(`#${this.name}-dropdown-container`).hasClass('open')) {
          $(`#${this.name}-dropdown-button`).trigger('click.bs.dropdown');
        }
      }
    },
  },
};
</script>
